import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadMemberStatusesByOutlookIds: IMemberStatusesLoadByOutlookIdsActionCreator = (outlookIds) => {
        return {
            type: ACTION_MEMBERSTATUSES_LOAD_BY_OUTLOOK_IDS,
            outlookIds
        }
    },
    LoadSuccess: IMemberStatusesLoadSuccessActionCreator = (data, responseStatus) => {
        return {
            type: ACTION_MEMBERSTATUSES_LOAD_SUCCESS,
            data,
            responseStatus
        }
    },
    LoadFailure: IMemberStatusesLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_MEMBERSTATUSES_LOAD_FAILURE,
            responseStatus
        }
    },
    Clear: IMemberStatusesClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_MEMBERSTATUSES_CLEAR,
            propertiesToClear
        }
    };



export const
    ACTION_MEMBERSTATUSES_LOAD_BY_OUTLOOK_IDS = "ACTION_MEMBERSTATUSES_LOAD_BY_OUTLOOK_IDS",
    ACTION_MEMBERSTATUSES_LOAD_SUCCESS = "ACTION_MEMBERSTATUSES_LOAD_SUCCESS",
    ACTION_MEMBERSTATUSES_LOAD_FAILURE = "ACTION_MEMBERSTATUSES_LOAD_FAILURE",

    ACTION_MEMBERSTATUSES_CLEAR = "ACTION_MEMBERSTATUSES_CLEAR";

export interface IMemberStatusesLoadByOutlookIdsAction {
    type: "ACTION_MEMBERSTATUSES_LOAD_BY_OUTLOOK_IDS";
    outlookIds: string[];
}

export interface IMemberStatusesLoadByOutlookIdsActionCreator {
    (outlookIds: string[]): IMemberStatusesLoadByOutlookIdsAction;
}

export interface IMemberStatusesLoadSuccessAction {
    type: "ACTION_MEMBERSTATUSES_LOAD_SUCCESS";
    data: {[index: string]: Dtos.MemberStatus};
    responseStatus: Dtos.ResponseStatus;
}

export interface IMemberStatusesLoadSuccessActionCreator {
    (
        data: {[index: string]: Dtos.MemberStatus},
        responseStatus: Dtos.ResponseStatus
    ): IMemberStatusesLoadSuccessAction;
}

export interface IMemberStatusesLoadFailureAction {
    type: "ACTION_MEMBERSTATUSES_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IMemberStatusesLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IMemberStatusesLoadFailureAction;
}

export interface IMemberStatusesClearAction {
    type: "ACTION_MEMBERSTATUSES_CLEAR";
    propertiesToClear?: string[];
}

export interface IMemberStatusesClearActionCreator {
    (propertiesToClear?: string[]): IMemberStatusesClearAction;
}
export type MemberStatusesAction =
    IMemberStatusesLoadByOutlookIdsAction |
    IMemberStatusesLoadFailureAction |
    IMemberStatusesLoadSuccessAction |
    IMemberStatusesClearAction;
